import { trpc } from '@web-app/utils/trpc';

const STALE_TIME = 5 * 60 * 1000;

/**
 * Fetches AI-generated session recap highlights for a patient.
 *
 * Standalone hook — works in any context (profile page, in-session, etc.).
 * The server resolves the last occurred appointment, looks up pre-generated
 * recap from `session_recap_history`, and falls back to on-the-fly AI
 * generation if none exists.
 */
export function useSessionRecap(patientId: string | null | undefined) {
  const { data, isPending, error } = trpc.sessionPrep.getRecap.useQuery(
    { patientId: patientId ?? '' },
    {
      enabled: !!patientId,
      staleTime: STALE_TIME,
      refetchOnWindowFocus: false,
      retry: 1,
    },
  );

  return {
    sessionRecap: data ?? null,
    isLoading: !!patientId && isPending,
    error: (error as Error | null) ?? null,
  };
}
